export const AllocationStatus = {
  Allocated: 'Allocated',
  Unallocated: 'Unallocated',
  Unknown: 'Unknown',
};
